<script>
export default {
  methods: {
    getAttr(obj, property) {
      return property.split('.').reduce((o, x) => o == undefined ? o : o[x], obj)
    },

    // model
    model(data, fieldName, forId) {
      let result = null;
      if (fieldName && fieldName.indexOf(".") > -1) {
        var fields = fieldName.split(".");
        result = data;
        for (let i = 0; i < fields.length; i++) {
          if (forId && i == fields.length - 1)
            result = result[fields[i] + "Id"];
          else result = result[fields[i]];
          if (result == null) {
            result = null;
            break;
          }
        }
      } else {
        if (forId) result = data[fieldName + "Id"];
        else result = data[fieldName];
      }

      return result;
    },
  }
}
</script>
